import React, { useEffect, useState } from "react";
import FichaUpload from "./CargarFichas";
import Cookies from "universal-cookie";
import { descargarDocumento } from "../Seguridad/DescargarDocumento";

const API = "https://suadesarrollo.azurewebsites.net/api";

function FichaList() {
  const cookie = new Cookies();
  const [fichas, setFichas] = useState([]);
  const [instituciones, setInstituciones] = useState([]);
  const [institucionId, setInstitucionId] = useState("");

  const username = "BasicAuth@icontec.org";
  const password = "yQLzqmR7eZSuAmQZUqhY";

  // 🔹 Cargar fichas
  const cargarFichas = async () => {
    try {
      const response = await fetch(`${API}/ObtenerFichasRepositorio`, {
        method: "GET",
        headers: {
          Authorization: "Basic " + btoa(username + ":" + password),
        },
      });

      const data = await response.json();
      setFichas(data);
    } catch (error) {
      console.error(error);
    }
  };

  // 🔹 Cargar instituciones
  const cargarInstituciones = async () => {
    try {
      const response = await fetch(`${API}/ObtenerInstituciones`, {
        method: "GET",
        headers: {
          Authorization: "Basic " + btoa(username + ":" + password),
        },
      });

      const data = await response.json();
      setInstituciones(data);
    } catch (error) {
      console.error(error);
    }
  };

  // 🔹 Buscar por institución
  const buscarPorInstitucion = async () => {
    if (!institucionId) {
      cargarFichas();
      return;
    }

    try {
      const response = await fetch(
        `${API}/ObtenerFichasRepositorioPorInstitucionId?InstitucionId=${institucionId}`,
        {
          method: "GET",
          headers: {
            Authorization: "Basic " + btoa(username + ":" + password),
          },
        },
      );

      const data = await response.json();
      setFichas(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    cargarFichas();
    cargarInstituciones();
  }, []);

  return (
    <div className="container">
      <div className="text-center">
        <div className="container-fluid">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Listado de fichas tecnicas
              </h6>
              {cookie.get("tipo_Usuario") == 1 ? (
                <FichaUpload recargar={cargarFichas} />
              ) : (
                <h></h>
              )}
            </div>

            <div className="card-body">
              <div className="row mb-3">
                {/* 🔹 SELECT DE INSTITUCIONES */}
                <div className="col-sm-4">
                  <select
                    className="form-control"
                    value={institucionId}
                    onChange={(e) => setInstitucionId(e.target.value)}
                  >
                    <option value="">-- Seleccione una institución --</option>
                    {instituciones.map((inst) => (
                      <option key={inst.id} value={inst.id}>
                        {inst.razon_Social}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-sm-2">
                  <button
                    className="btn btn-secondary"
                    onClick={buscarPorInstitucion}
                  >
                    Buscar
                  </button>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Institución ID</th>
                      <th>Institución</th>
                      <th>Ciclo</th>
                      <th>Tipo Visita</th>
                      <th>Archivo</th>
                      <th>Año</th>
                    </tr>
                  </thead>

                  <tbody>
                    {fichas.map((ficha, index) => (
                      <tr key={index}>
                        <td>
                          {instituciones.find(
                            (i) => i.id === ficha.institucionId,
                          )?.nombre || ficha.institucionId}
                        </td>
                        <td>{ficha.institucionNombre}</td>
                        <td>{ficha.ciclo}</td>
                        <td>{ficha.nombre}</td>
                        <td>
                          {ficha.ubicacion ? (
                            <button
                              className="btn btn-success"
                              onClick={() =>
                                descargarDocumento(ficha.ubicacion)
                              }
                            >
                              Descargar Adjunto
                            </button>
                          ) : (
                            "Sin archivo"
                          )}
                        </td>
                        <td>{ficha.ano}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FichaList;
